import HTTP from "@/_helpers/http";
import { COMPANYINFO__MUTATIONS } from '../mutation-types'
import { COMPANYINFO__API } from '@/_helpers/urls'
import { COMPANYINFO__ACTIONS } from '../action-types'

// State
const state = {
    generalInfo: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [COMPANYINFO__MUTATIONS.COMPANYINFO](state, data) {
        state.generalInfo = data;
    },
};

// Actions
const actions = {
    async [COMPANYINFO__ACTIONS.COMPANYINFO]({ commit, state }) {
        try {
            const url = `${COMPANYINFO__API.COMPANYINFO}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);

            if (response.status === 200) {
                commit(COMPANYINFO__MUTATIONS.COMPANYINFO, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
